export default __webpack_public_path__ + "static/media/bowsersfury1.70327886.mov";